/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_ManageInputs */

const en_views_manage = /** @type {(inputs: Views_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage views`)
};

const de_views_manage = /** @type {(inputs: Views_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansichten verwalten`)
};

/**
* | output |
* | --- |
* | "Manage views" |
*
* @param {Views_ManageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_manage = /** @type {((inputs?: Views_ManageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_ManageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_manage(inputs)
	return en_views_manage(inputs)
});